<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0" v-on:keypress.enter.prevent="searchImportProduct">
                    <input
                        class="form-control mr-sm-2"
                        type="search"
                        placeholder="รหัสสินค้า"
                        aria-label="Search"
                        v-model="form.code"/>
                    <date-picker
                            v-model="form.date"
                            type="date"
                            :format="changeFormat"
                            :lang="lang"
                            placeholder="วันที่อัพเดต" >
                    </date-picker>
                    &nbsp
                    <button
                        class="btn btn-success my-2 my-sm-0"
                        type="button"
                        @click="searchImportProduct">
                        <icon name="search"></icon> ค้นหา
                    </button>
                    &nbsp
                    <button type="button" class="btn btn-primary my-2 my-sm-0"
                            @click="showPrintReportModal">
                        <icon name="file-download"></icon> พิมพ์รายงาน
                    </button>
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">รหัสสินค้า</th>
                    <th scope="col">ชื่อสินค้า</th>
                    <th scope="col">จำนวนสินค้านำเข้า</th>
                    <th scope="col">เครื่อง</th>
                    <th scope="col">วัน/เวลา ที่นำเข้า</th>
                    <th scope="col">ผู้นำเข้า</th>
                    <th scope="col" v-if="canViewSuperAdmin">แก้ไข / ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in importProducts">
                    <td>
                        <template v-if="data.product">
                            {{data.product.sku}}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.product">
                            {{data.product.name}}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>{{ data.quantity | amount }}</td>
                    <td>
                        <template v-if="data.machine">
                            {{ data.machine.name }}
                        </template>
                        <template v-else>
                            <p>-</p>
                        </template>
                    </td>
                    <td>{{ data.updated_at | moment("DD/MM/YYYY , HH:mm:ss") }}</td>
                    <td>
                        <template v-if="data.user">
                            {{ data.user.name }}
                        </template>
                        <template v-else>
                            -
                        </template>

                    </td>
                    <td v-if="canViewSuperAdmin">
                        <a @click="showImportProduct(data.id)"><icon name="pencil-alt"></icon></a>
                        &nbsp&nbsp
                        <a @click="showDeleteModal(data.id)"><icon name="trash"></icon></a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="importProducts.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getProductsImportPage">
            </vue-pagination>
        </div>
        <br />
        <!-- Modal Delete -->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br />
                <button
                    type="button"
                    class="btn btn-success"
                    @click="deleteImportProduct">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideDeleteModal">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!-- Modal Report Print -->
        <b-modal hide-header hide-footer ref="report_print">
            <div style="text-align: center;">
                <h4>พิมพ์ข้อมูลนำเข้าสินค้า</h4>
                <br />
                <div class="row form-group">
                    <div class="col-sm-4">
                        <label>วันที่นำเข้าสินค้า</label>
                    </div>
                    <div class="col-sm-6">
                        <date-picker
                                v-model="date_print"
                                type="date"
                                :format="changeFormat"
                                :lang="lang"
                                placeholder="วันที่นำเข้าสินค้า" >
                        </date-picker>
                    </div>
                </div>
                <button @click="printReportImportProduct"
                        type="button"
                        class="btn btn-primary">
                    <icon name="print"></icon>
                    พิมพ์
                </button>
                &nbsp&nbsp
                <button @click="hidePrintReportModal"
                        type="button"
                        class="btn btn-outline-secondary">
                    <icon name="times"></icon>
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!-- Modal edit Data -->
        <b-modal
            hide-footer
            ref="edit_data"
            id="import"
            title="นำเข้าวัตถุดิบ">
            <div v-if="edit_product.product">
                <b-row sm="10" v-if="edit_product.product">
                    <b-col sm="4" class="col text-right">
                        <label>รหัสสินค้า</label>
                    </b-col>
                    <b-col sm="6"><input
                            class="form-control"
                            type="text"
                            v-model="edit_product.product.sku" disabled/></b-col>
                </b-row>
                <br />
                <b-row sm="10" v-if="edit_product.product">
                    <b-col sm="4" class="col text-right">
                        <label>ชื่อสินค้า</label></b-col>
                    <b-col sm="6">
                        <input
                            class="form-control"
                            type="text"
                            v-model="edit_product.product.name" disabled/>
                    </b-col>
                </b-row>
                <br />
                <b-row sm="11">
                    <b-col sm="4" class="col text-right">
                        <label>จำนวนสินค้านำเข้า</label>
                    </b-col>
                    <b-col sm="6"><input
                            class="form-control"
                            type="text"
                            v-model="edit_product.quantity"/></b-col>
                </b-row>
                <br />
                <b-row sm="11">
                    <b-col sm="4" class="col text-right">
                        <label>เครื่อง</label>
                    </b-col>
                    <b-col sm="6">
                        <multiselect
                            v-model="edit_product.machine"
                            :options="machine"
                            label="name"
                            track-by="name">
                        </multiselect>
                    </b-col>
                </b-row>
                <br />
                <b-row>
                    <div class="col text-center">
                        <button
                            type="button"
                            class="btn btn-success"
                            @click="saveImportProduct">
                            <icon name="save" style="width: 25px"></icon>
                            บันทึก</button>&nbsp&nbsp
                        <button
                            type="button"
                            class="btn btn-outline-secondary"
                            @click="hideEditModal">
                            <icon name="times" style="width: 25px"></icon>
                            ยกเลิก
                        </button>
                    </div>
                </b-row>
            </div>
            <!--<pre class="alert alert-primary">{{ edit_product }}</pre>-->
        </b-modal>
        <!--<pre class="alert alert-primary">{{ importProducts }}</pre>-->
    </div>
</template>

<script>
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
import Modal from "bootstrap-vue/es/components/modal/modal";
import VuePagination from "../../Pagination";
import format from 'date-fns/format'
import { domain } from "../../../util/Constants";
import DatePicker from 'vue2-datepicker'
import moment from "moment";
import {
    canViewSuperAdmin
} from "../../../util/Permissions";
export default {
    components: {
        VuePagination,
        Modal,
        Multiselect,
        DatePicker
    },
    name: "import-products",
    data() {
        return {
            id: "",
            dateFormat: 'D/MM/YYYY',
            date_print : "",
            form: {
                code: "",
                date: "",
                shift: "",
                machine: "",
                event_submit : false
            },
            importProducts : [],
            dataPaginate:{
                current_page :1,
                from : 1,
                last_page : 1,
                per_page : 1,
                total : 1,
                to : 1
            },
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/'+year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        };
    },
    created() {
        this.$store.dispatch("ImportProduct/get").then(res=>{
            this.importProducts = res.data;
            this.dataPaginate = {
                current_page : res.current_page,
                from : res.form,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            }
        });
        this.$store.dispatch("Machine/get");
        this.domain = domain + '/product-import-pdf';
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            edit_product: state => {
                return state.ImportProduct.replace_data;
            },
            machine: state => {
                return state.Machine.data;
            },
        })
    },
    methods: {
        clearDate(){
            this.form.date = "";
        },
        LabelName(option) {
            return `${option.id}`;
        },
        //Modal
        showDeleteModal(id) {
            this.id = id;
            this.$refs.delete_item.show();
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide();
        },

        showEditModal(id) {
            this.id = id;
            this.$refs.edit_data.show();
        },
        hideEditModal() {
            this.$refs.edit_data.hide();
        },

        showPrintReportModal() {
            this.$refs.report_print.show();
        },
        hidePrintReportModal() {
            this.$refs.report_print.hide();
        },

        //API
        showImportProduct(id) {
            this.$store.dispatch("ImportProduct/show", id).then(()=>{
                this.machine.forEach(machine=>{
                    if(machine.machine_id===this.edit_product.machine){
                        this.form.machine = machine;
                    }
                })
            });
            this.showEditModal(id);
        },
        deleteImportProduct() {
            this.$store.dispatch("ImportProduct/delete", this.id).then(() => {
                this.hideDeleteModal();
                this.$store.dispatch("ImportProduct/get");
            });
        },
        saveImportProduct() {
            if(this.edit_product.quantity < 1){
                alert("กรุณาใส่จำนวนให้ถูกต้อง");
            }
            else{
                let data = {
                    product_id:this.edit_product.product_id,
                    quantity: this.edit_product.quantity,
                    machine_id: "", //send machine_id
                    user_id: this.user.id
                };
                if( this.edit_product.machine){
                    data.machine_id = this.edit_product.machine.id
                }
                this.$store
                    .dispatch("ImportProduct/update", {
                        id: this.id,
                        data: data
                    })
                    .then(() => {
                        this.hideEditModal();
                        this.$store.dispatch("ImportProduct/get");
                    });
            }
        },
        searchImportProduct() {
            if(this.form.date){
                this.form.date = moment(this.form.date).format("YYYY-MM-DD");
            }
            else{
                this.form.date = ""
            }
            this.event_submit = true;
            this.$store.dispatch("ImportProduct/search", {
                code: this.form.code,
                date: this.form.date
            }).then(res=>{
                this.importProducts = res.data;
                this.dataPaginate = {
                    current_page : res.current_page,
                    from : res.form,
                    last_page : res.last_page,
                    per_page : res.per_page,
                    total : res.total,
                    to : res.to
                }
            });
        },
        getProductsImportPage(){
            const page = this.dataPaginate.current_page;
            // paginate search
            if(this.form.date){
                this.form.date = moment(this.form.date).format("YYYY-MM-DD");
            }
            else{
                this.form.date = ""
            }
            if(this.event_submit){
                this.$store.dispatch('ImportProduct/search',{
                    page : page,
                    code: this.form.code,
                    date: this.form.date
                });
            }else{
                //paginate get data
                this.$store.dispatch('ImportProduct/get',page)
            }
        },
        printReportImportProduct(){
            if(!this.date_print){
                alert("กรุณาเลือกวันที่นำเข้า ที่ต้องการพิมพ์")
            }
            else{
                let date = moment(this.date_print).format("YYYY-MM-DD");
                window.open(this.domain+"?date="+date);
                this.date_print = "";
                this.hidePrintReportModal();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
    .picker{
        border: 0;
    }
</style>
